module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/locale/zh_Hant.json
// module id = 1266
// module chunks = 0